import { Box, Grid, Step, StepLabel, Stepper } from "@mui/material";
// useselecter allows us to select a part of the store
//
import { useDispatch, useSelector } from "react-redux";
import Confirmation from "./Components/Confirmation";
import EnterDetails from "./Components/EnterDetails";
import UploadDocs from "./Components/UploadDocs";
import {
  cancel,
  clearErrors,
  currentPage,
  errors,
  getDropdownData,
} from "./features/AppSlice";
import { SARSHeader, ErrorModal, YoutubeEmbed } from "@soqs/common";
import React, { useEffect } from "react";
import Captcha from "./Components/Captcha";
import { getVideo} from "./features/API";

export const PAGES = {
  EnterDetails: 0,
  FraudInformation: 1,
  Captcha: 2,
  UploadSupportingDocs: 3,
  Confirmation: 4,
};
function App() {
  const dispatch = useDispatch();
  const pageState = useSelector(currentPage);
  const errorState = useSelector(errors);
  useEffect(() => {
    dispatch(getDropdownData());
    return () => {};
  }, []);

  const Pager = ({ page }) => {
    switch (page) {
      case PAGES.EnterDetails:
      case PAGES.FraudInformation:
        return <EnterDetails />;
      case PAGES.Captcha:
        return <Captcha />;
      case PAGES.UploadSupportingDocs:
        return <UploadDocs />;
      case PAGES.Confirmation:
        return <Confirmation />;
      default: {
        dispatch(cancel());
      }
    }
  };

  const getStepFromPage = (page) => {
    switch (page) {
      case PAGES.EnterDetails:
        return 0;
      case PAGES.FraudInformation:
        return 1;
      case PAGES.Captcha:
        return 2;
      case PAGES.UploadSupportingDocs:
        return 3;
      case PAGES.Confirmation:
        return 4;
      default: {
        return 4;
      }
    }
  };

  const StepperWrapper = ({ page }) => (
    <>
      <Box sx={{ display: { xs: "block", md: "none" } }}>
        <Stepper activeStep={getStepFromPage(page)}>
          <Step
            key={PAGES.EnterDetails}
            completed={pageState > PAGES.EnterDetails}
          >
            {pageState == PAGES.EnterDetails ? (
              <StepLabel>Taxpayer Details</StepLabel>
            ) : (
              <StepLabel></StepLabel>
            )}
          </Step>
          <Step
            key={PAGES.FraudInformation}
            completed={pageState > PAGES.FraudInformation}
          >
            {pageState == PAGES.FraudInformation ? (
              <StepLabel>Fraud Information</StepLabel>
            ) : (
              <StepLabel></StepLabel>
            )}
          </Step>
          <Step key={PAGES.Captcha} completed={pageState > PAGES.Captcha}>
            {pageState == PAGES.Captcha ? (
              <StepLabel>Captcha</StepLabel>
            ) : (
              <StepLabel></StepLabel>
            )}
          </Step>
          <Step
            key={PAGES.UploadSupportingDocs}
            completed={pageState > PAGES.UploadSupportingDocs}
          >
            {pageState == PAGES.UploadSupportingDocs ? (
              <StepLabel>Upload Supporting Documentation</StepLabel>
            ) : (
              <StepLabel></StepLabel>
            )}
          </Step>
        </Stepper>
      </Box>

      <Box sx={{ display: { xs: "none", md: "block" } }}>
        <Stepper activeStep={getStepFromPage(page)}>
          <Step
            key={PAGES.EnterDetails}
            completed={pageState > PAGES.EnterDetails}
          >
            <StepLabel>SARS Employee Details</StepLabel>
          </Step>
          <Step
            key={PAGES.FraudInformation}
            completed={pageState > PAGES.FraudInformation}
          >
            <StepLabel>Fraud Information</StepLabel>
          </Step>
          <Step key={PAGES.Captcha} completed={pageState > PAGES.Captcha}>
            <StepLabel>Captcha</StepLabel>
          </Step>
          <Step
            key={PAGES.UploadSupportingDocs}
            completed={pageState > PAGES.UploadSupportingDocs}
          >
            <StepLabel>Upload Supporting Documentation</StepLabel>
          </Step>
        </Stepper>
      </Box>
    </>
  );

  return (
    <>
      <SARSHeader
        // onLogoClick={() => dispatch(cancel())}
        onLogoClick={() => window.navigation.navigate(window.location)}
        pageTitle="Report SARS Employee Corruption"
      />
      <div className="App">
        <Grid
          container
          spacing={2}
          style={{
            minHeight: "80vh",
            paddingLeft: "2%",
            paddingRight: "2%",
            justifyContent: "center",
          }}
          alignContent="flex-start"
        >
          <Grid
            size={{ xs: 12 }}
            style={{ paddingTop: "8vh", maxWidth: "1500px" }}
          >
            <StepperWrapper page={pageState} />
          </Grid>
          <Grid
            size={{ xs: 12 }}
            style={{ paddingTop: "2vh", maxWidth: "1500px" }}
          >
            <Pager page={pageState} />
            <ErrorModal
              title={
                errorState?.errortitle
                  ? errorState?.errortitle
                  : typeof errorState?.error === "string" &&
                    errorState?.error?.indexOf("|") > -1
                  ? errorState?.error?.split("|")[0]
                  : "Error"
              }
              open={errorState !== null}
              onClose={() => {
                if (errorState?.fatal) {
                  dispatch(cancel());
                } else {
                  dispatch(clearErrors());
                }
              }}
              subheader={
                Array.isArray(errorState?.error) ? (
                  <ul>
                    {errorState?.error.map((e, idx) => (
                      <li key={idx}>{e.replace("- ", "")}</li>
                    ))}
                  </ul>
                ) : (
                  <p
                    dangerouslySetInnerHTML={{
                      __html:
                        errorState?.error?.indexOf("|") > -1
                          ? errorState?.error?.split("|")[1]
                          : errorState?.error,
                    }}
                  ></p>
                )
              }
            />
          </Grid>
        </Grid>
      </div>
      <YoutubeEmbed appCode="ACR" fetchVideo={getVideo} initialPosition="top-right" />
    </>
  );
}

export default App;
